import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import UserList from '../../components/Entity/Users/List/List';
 
const UsersPage = () => {
  return <Layout nonav={0} fullwidth={0}>
   
      <UserList></UserList>
 
  </Layout>;
}

export default UsersPage;